export default {
    100: 'The caller must be the pool admin',
    101: 'The caller must be the emergency admin',
    102: 'P_IMPL_GET_FAIL',
    103: 'The caller must be the contracts admin',
    104: 'The caller of the function is not the staking pool configurator',
    105: 'The caller of the function is not the lending pool factory',
    106: 'NON_CONTRACT_CALL',
    107: 'VL_PROXY_CONTRACT_UNINITIALIZED',
    108: 'MATH_MULTIPLICATION_OVERFLOW',
    109: 'MATH_DIVISION_BY_ZERO',
    110: 'INVALID_FEE',
    111: 'NO_INVALID_PENDING_OWNER',
    112: 'NO_NO_NODE_PERMISSION',
    113: 'NO_NOT_DELEGATED',
    114: 'NO_DELEGATED',
    115: 'NO_INVALID_OWNER_PROPOSAL',
    116: 'NO_EXIST_OTHER_BENEFICIARY',
    151: 'Amount must be greater than 0',
    152: 'Node available amount must be greater than 0',
    153: 'Node actual withdraw amount must be greater than 0',
    154: 'SPLP_AMOUNT_NOT_EXCEED_MAX_SEAL_LOAD',
    155: 'SPLP_AMOUNT_NOT_EXCEED_MAX_WITHDRAW_LOAD',
    156: 'SPLP_SAFETY_BUFFER_LIMIT',
    157: 'SPLP_NO_DEBT',
    158: 'SPLP_EXIST_DEBT',
    159: 'SPLP_DEBT_RATIO_TOO_HIGH',
    160: 'SPLP_POSITION_EMPTY',
    161: 'SPLP_AMOUNT_AT_LEAST_MIN_LOAD_AMOUNT',
    162: 'Pool is paused',
    163: 'SPLP_ONLY_ACCEPTS_NEW_NODES',
    164: 'SPLP_POSITION_NOT_ENOUGH',
    165: 'SPLP_IS_PAUSED',
    166: 'SPLP_NOT_EXIST',
    167: 'SPLP_NODE_CAPACITY_EXCEEDED',
    168: 'SPLP_NODE_EXIST',
    201: 'Amount must be greater than 0',
    202: 'The minimum stake amount is 1FIL',
    203: 'Insufficient available liquidity',
    204: 'SP_NOT_ENOUGH_AVAILABLE_USER_BALANCE',
    205: 'SP_INVALID_INTEREST_RATE_MODE_SELECTED',
    206: 'SP_AMOUNT_BIGGER_THAN_MAX_LOAN_SIZE_STABLE',
    207: 'SP_INVALID_ADDRESS',
    208: 'Staking Pool is paused',
    251: 'The caller of this function must be a staking pool',
    252: 'CT_INVALID_MINT_AMOUNT',
    253: 'CT_INVALID_BURN_AMOUNT',
    254: 'CT_INVALID_TREASURY_ADDRESS',
    255: 'SDT_STABLE_DEBT_OVERFLOW',
    86: 'INVALID_LIQUIDATION_FACTOR',
    83: 'INVALID_LEVERAGE',
    84: 'INVALID_LIQ_THRESHOLD',
    93: 'N_INVALID_BENEFICIARY_PROPOSAL',
    60: 'N_MUST_BENEFICIARY_ROLE',
    61: 'N_MUST_EMPTY_GUARANTEE',
    94: 'N_INVALID_OWNER',
    99: 'N_MUST_OWNER_ROLE',
    97: 'N_SENDER_NOT_OPERATOR',
    63: 'VL_INVALID_BORROWING_AUTHENTICATION',
    70: 'VL_AVAILABLE_QUOTA_AT_LEAST_MAX_FIL_SUPPLY',
    66: 'VL_DEBT_RATE_LESS_THAN_LIQUIDATION_THRESHOLD',

    300: 'INVALID PERMISSIONS',
    301: 'INVALID ADDRESS ',
    302: 'The whitelisted address has been Mint ',
    303: 'The current address is not whitelisted ',
    304: 'MINT is not currently open',
    305: 'MINT price shortage',
    306: 'The number of current addresses has exceeded the maximum mint number!',
    307: 'The number of current addresses has exceeded the maximum wlmint number!',
    308: 'INVALID_POOL_ADDRESS',
    309: 'STFIL POOL CALL FAILED ',
    310: 'WRONG_PERCENTAGE_RANGE ',
    311: 'MIN_POWER_MORE_HALF_MAX_POWER ',
    312: 'INVALID_ADDRESS ',
    313: 'Referral code must be in the range',
    314: 'Referral code already exist',
    315: 'Referral code num limited ',
    316: 'Math multiplication overflow',
    317: 'MATH_DIVISION_BY_ZERO',
}
